<template lang="pug">
    .column.is-12
      TbGrupos(:Comp="Comp")
  </template>
  
  <script>
    import TbGrupos from './TbGrupos.vue'
    export default {
      name: 'ContainerGruposSubgrupos',
      components: { TbGrupos },
      props: {
        Comp: {
          type: Array,
          default: () => []
        },
      },
      data() {
        return {}
      },
      methods: { }
    }
  </script>
  
  <style lang="scss" scoped>
  </style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/cuartocontrol/componentes/ContainerGruposSubgrupo.vue